import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';

// ── Types ────────────────────────────────────────────────────────────────────

export interface MakeSummary {
  id: number;
  make: string;
  modelCount: number;
}

export interface ModelSummary {
  id: number;
  model: string;
}

// ── Service ──────────────────────────────────────────────────────────────────

export const vehicleManagementService = {
  // Makes
  async getMakes(): Promise<MakeSummary[]> {
    const { data } = await axiosInstance.get(API_ENDPOINTS.VEHICLE_MANAGEMENT.MAKES);
    return data?.data ?? data;
  },

  async createMake(name: string): Promise<{ id: number; make: string }> {
    const { data } = await axiosInstance.post(API_ENDPOINTS.VEHICLE_MANAGEMENT.MAKES, { name });
    return data?.data ?? data;
  },

  async deleteMake(name: string): Promise<{ deleted: number }> {
    const { data } = await axiosInstance.delete(
      API_ENDPOINTS.VEHICLE_MANAGEMENT.DELETE_MAKE(name),
    );
    return data?.data ?? data;
  },

  // Models
  async getModels(make: string): Promise<ModelSummary[]> {
    const { data } = await axiosInstance.get(API_ENDPOINTS.VEHICLE_MANAGEMENT.MODELS, {
      params: { make },
    });
    return data?.data ?? data;
  },

  async createModel(make: string, model: string): Promise<{ id: number; make: string; model: string }> {
    const { data } = await axiosInstance.post(API_ENDPOINTS.VEHICLE_MANAGEMENT.MODELS, {
      make,
      model,
    });
    return data?.data ?? data;
  },

  async deleteModel(make: string, model: string): Promise<{ deleted: number }> {
    const { data } = await axiosInstance.delete(API_ENDPOINTS.VEHICLE_MANAGEMENT.MODELS, {
      params: { make, model },
    });
    return data?.data ?? data;
  },
};
